var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(parseInt(_vm.historyCredit.credit) === 0)?_c('label',[_vm._v(" -"+_vm._s(_vm.historyCredit.debit)+" ")]):_c('label',[_vm._v(" "+_vm._s(_vm.historyCredit.credit)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }